/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type GetUnproxiedMcpServerUsageRequestBody = {
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
  /**
   * The unproxied MCP server's vendor URL
   */
  url: string;
};

/** @internal */
export type GetUnproxiedMcpServerUsageRequestBody$Outbound = {
  from: string;
  to: string;
  url: string;
};

/** @internal */
export const GetUnproxiedMcpServerUsageRequestBody$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerUsageRequestBody$Outbound,
    GetUnproxiedMcpServerUsageRequestBody
  > = z.object({
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
    url: z.string(),
  });

export function getUnproxiedMcpServerUsageRequestBodyToJSON(
  getUnproxiedMcpServerUsageRequestBody: GetUnproxiedMcpServerUsageRequestBody,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerUsageRequestBody$outboundSchema.parse(
      getUnproxiedMcpServerUsageRequestBody,
    ),
  );
}
